import axios from "axios";
import { axiosInstance } from "./axiosInstance";

/**
 * 1. S3 Presigned URL을 발급받아 이미지를 직접 업로드하고, 최종 URL을 반환합니다.
 */
export const uploadImageToS3 = async (file: File): Promise<string> => {
  try {
    // 1-1. 백엔드에 Presigned URL 요청 (axiosInstance 사용)
    const response = await axiosInstance.get(`/api/s3/presigned-url`, {
      params: {
        filename: file.name,
        folder: "inquiries" // S3의 inquiries 폴더에 저장
      }
    });

    const { presignedUrl, imageUrl } = response.data.data;

    // 💡 1-2. S3로 파일 직접 업로드 (기본 axios 사용)
    // 주의: 여기서는 axiosInstance를 쓰면 안 됩니다! (인터셉터가 불필요한 인증 헤더를 붙여 S3에서 거절당할 수 있음)
    await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": file.type
      }
    });

    // 1-3. 업로드 완료된 이미지의 S3 URL 반환
    return imageUrl;

  } catch (error) {
    console.error("S3 이미지 업로드 에러:", error);
    throw error;
  }
};

/**
 * 2. 백엔드에 1:1 문의 데이터를 전송합니다.
 */
export const createInquiry = async (data: { category: string; title: string; content: string; imageUrls: string[] }) => {
  const response = await axiosInstance.post(`/api/cs/inquiries`, data);

  // 💡 추가된 핵심 로직: 백엔드에서 success가 false로 오면 에러를 던짐!
  if (!response.data.success) {
    throw new Error(response.data.message);
  }

  return response.data;
};

/**
 * 3. 내 1:1 문의 내역 목록을 조회합니다.
 */
export const getMyInquiries = async () => {
  try {
    const response = await axiosInstance.get(`/api/cs/inquiries/me`);
    // 백엔드에서 내려주는 ApiResponse의 형태가 { success: true, data: [...] } 이므로 바로 반환
    return response.data;
  } catch (error) {
    console.error("내 문의 내역 조회 에러:", error);
    throw error;
  }
};

/**
 * [공지사항] 사용자용 목록 조회 API
 */
export const getPublicNotices = async (page = 0, size = 20) => {
  try {
    // 💡 환경변수를 수동으로 조합할 필요 없이, 기존에 세팅된 axiosInstance를 활용합니다.
    const response = await axiosInstance.get(`/api/cs/notices`, {
      params: { page, size }
    });
    return response.data;
  } catch (error) {
    console.error("공지사항 목록 조회 에러:", error);
    throw error;
  }
};